import { render, staticRenderFns } from "./AllHeader.vue?vue&type=template&id=96486188&scoped=true&"
import script from "./AllHeader.vue?vue&type=script&lang=js&"
export * from "./AllHeader.vue?vue&type=script&lang=js&"
import style0 from "./AllHeader.vue?vue&type=style&index=0&id=96486188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96486188",
  null
  
)

export default component.exports